import * as React from "react";

import { constantFormat } from "../../../helpers/constants";
import { DefaultColumn, TableColumn, TableDtRefColumn } from "./DefaultColumn/DefaultColumn";
import { resolveFieldData } from "../../../helpers/utils/FieldDataResolver";

export const DateColumn: React.FC<TableDtRefColumn> = (c) => {
  const dateFilter = (value, filter) => {
    if (
      filter === undefined ||
      filter === null ||
      (typeof filter === "string" && filter.trim() === "")
    ) {
      return true;
    }

    if (value === undefined || value === null) {
      return false;
    }
    return constantFormat.DateToString(value).indexOf(filter) > -1;
  };
  const bodyTemplate = (row: any, col: any) => {
    const data = resolveFieldData(row, col.field);
    if(data)
      return <span className="pda-column-body-date">{constantFormat.DateToString(data)}</span>
    return "";
  }
  return DefaultColumn({
    bodyClassName: `pda-column-date ${c.bodyClassName ?? ``}`,
    headerClassName: `pda-column-date-header ${c.headerClassName ?? ``}`,
    filterMatchMode: "custom",
    filterFunction: dateFilter,
    body: bodyTemplate,
    ...c,
  });
};
